function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import FilesService from '@/apps/data-platform/services/security/files_service';
import tasks from '@/js/tasks';
export default {
  name: 'ReportTabPage',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          kdomain: null,
          ksubdomain: null,
          kbusiness_term: null
        };
      }
    }
  },
  computed: _objectSpread({
    filterDomain: function filterDomain() {
      return this.selectDomain;
    },
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (x) {
        return x.domain.includes(_this.kdomain);
      });
      return selectbSubdomain;
    },
    filterBusinessTerm: function filterBusinessTerm() {
      var _this2 = this;
      var selectbBusinessTerm = this.selectBusinessTerm ? this.selectBusinessTerm.filter(function (x) {
        return x.ksubdomain == _this2.ksubdomain;
      }) : [];
      return selectbBusinessTerm;
    },
    showButtonAttachment: function showButtonAttachment() {
      var userInfo = window.userInfo;
      var dataOperator = this.item.data_operator;
      var userRoles = userInfo.userRoles || [];
      return userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD) || dataOperator === userInfo.email;
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])),
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      MODAL_PREVIEW_FILE: 'MODAL_PREVIEW_FILE',
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdomain: null,
      ksubdomain: null,
      kbusiness_term: null,
      bt_add: {
        kdomain: null,
        domain_description: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      },
      page_add: {
        name: '',
        description: '',
        preview: ''
      },
      inputUploadImage: null,
      key_table: 1,
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      }
    };
  },
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
  },
  mounted: function mounted() {},
  methods: {
    filterPages: function filterPages() {
      if (this.item.pages) return this.item.pages.filter(function (x) {
        return !x.delete;
      });
      return [];
    },
    onFileChangeImage: function onFileChangeImage(event) {
      var _this3 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      fileReader.onload = function (e) {
        var filename = file.name;
        var data = {
          content: e.target.result,
          filename: "".concat(_this3.item.luid, "/files/").concat(filename),
          name: filename,
          type: BUCKET_DIRECTORY_TYPES.REPORTS,
          domain_source: _this3.domain_table
        };
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              domainTable: _this3.domain_table,
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            _this3.page_add.preview = _file;
            _this3.inputUploadFile = null;
          } else {
            _this3.inputUploadFile = null;
            tasks.toast.error(res['message']);
            //this.$toast.warning(res['message'])
          }
        });
        var preview_data = {
          content: data,
          filename: filename
        };
        console.log(preview_data);
        _this3.page_add.preview_data = preview_data;
      };
      fileReader.readAsDataURL(file);
    },
    validAddPage: function validAddPage() {
      if (this.page_add.name.trim().length == 0) {
        tasks.toast.error("Enter the name!");
        //this.$toast.warning("Enter the name!")
        return false;
      }
      if (this.page_add.description.trim().length == 0) {
        tasks.toast.error("Enter the description!");
        //this.$toast.warning("Enter the description!")
        return false;
      }
      return true;
    },
    onAddPage: function onAddPage() {
      console.log(this.item);
      if (!this.validAddPage()) return;
      if (this.item.pages) this.item.pages.push(this.page_add);else this.item.pages = [this.page_add];
      this.limpiarAdd();
    },
    limpiarAdd: function limpiarAdd() {
      this.page_add = {
        name: '',
        description: ''
      };
    },
    onClickLink: function onClickLink(file) {
      var _this4 = this;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this4.isLoading = false;
        if (response.success) {
          _this4.image = response.data.base64;
          _this4.dataImage = response.data;
          _this4.filename = response.data.name.split('/').pop();
          _this4.contentType = response.data.contentType;
          _this4.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
          _this4.$bvModal.show(_this4.MODAL_PREVIEW_FILE);
        } else {
          _this4.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          //alert(response.message)
        }
      });
    },
    onRemovePage: function onRemovePage(item) {
      var index = this.item.pages.indexOf(item);
      this.item.pages.splice(index, 1);
      if (this.item.pages_delete) {
        this.item.pages_delete.push(item);
      } else {
        this.item.pages_delete = [];
        this.item.pages_delete.push(item);
      }
      this.key_table += 1;
    }
  }
};